import { EmptyState, PageHeader } from '@aigovops/design-system';

/**
 * /o/:orgSlug/disclosure-requests — Placeholder for org-wide disclosure
 * request tracking.
 *
 * NAV-4-4: Wired into the org sidebar so the navigation is complete.
 * Full implementation (org-wide request rollup, status dashboard,
 * bulk operations) lands in a later phase.
 */
export function OrgDisclosureRequests() {
  return (
    <div style={{ display: 'grid', gap: 'var(--space-4)' }}>
      <PageHeader
        title="Disclosure Requests"
        subtitle="Organization-wide supplier disclosure request tracking."
      />
      <EmptyState
        title="Disclosure Requests"
        description="Organization-wide disclosure request tracking is coming soon. Workspace-level requests are available in each workspace's Third-Party Risk section."
      />
    </div>
  );
}
